import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function BookingBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-18" data-mp="3sd5u4f2wn3pr">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-sand-dark/50 bg-ivory/95 px-4 py-3 backdrop-blur-md sm:hidden" initial={{
      y: 80
    }} animate={{
      y: 0
    }} exit={{
      y: 80
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} data-id="element-19" data-mp="3nkuvdfjwhnys">
          <div className="flex items-center justify-between gap-4" data-id="element-20" data-mp="39lle0cjyknt8">
            <div data-id="element-21" data-mp="39mwi6dhbfxkv">
              <p className="font-serif text-lg leading-none text-forest-deep" data-id="element-22" data-mp="34m8sbv4tpms8">
                Your home in Taveuni
              </p>
              <p className="mt-1 text-[11px] uppercase tracking-[0.14em] text-forest-deep/50" data-id="element-23" data-mp="gdcwsk8a7nk8">
                Breakfast included
              </p>
            </div>
            <a href="#book" className="rounded-full bg-ocean px-6 py-3.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory" data-id="element-24" data-mp="7dzmxqg8wwyz">
              Book
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}